<template>
  <BaseWorkPageLayout
    :title="$t('global.export_invoices')"
    icon="file-export"
    with-back-button
  >
    <template #default>
      <PageSection disable-sticky-margin :title="$t('global.export_invoices')">
        <div>
          <div>
            <div class="mt-2.5">
              <BaseShowEditSelectSimple
                v-if="companies"
                :editionMode="true"
                :label="$t('attributes.company')"
                :placeholder="$t('attributes.company')"
                name="company"
                v-model="company"
                defaultValue=""
                :options="companies"
              />
            </div>
            <div class="mt-2.5">
              <div class="text-sm text-gray-500 capitalize-first">
                {{ $t('global.invoice_range') }}
              </div>
              <BaseDateRangeInput
                :placeholder="$t('global.from_to')"
                separator=" - "
                :formatter="date_formatter"
                v-model="due_date"
                :errors="errors.period"
              />
            </div>
            <div class="mt-4">
              <div class="text-sm text-gray-500 capitalize-first">
                {{ $t('global.with_exported') }}
              </div>
              <BaseCheckBox
                label=""
                name="with_exported"
                :value="with_exported"
                @checkboxChange="getInputValue"
              />
            </div>
            <div class="mt-4">
              <div class="text-sm text-gray-500 capitalize-first">
                {{ $t('global.mark_exported') }}
              </div>
              <BaseCheckBox
                label=""
                name="mark_exported"
                :value="mark_exported"
                @checkboxChange="getInputValue"
              />
            </div>
          </div>
          <div class="mt-4 flex flex-row-reverse">
            <BaseButton
              color="primary"
              icon="arrow-square-down"
              @click="submitForm"
              class=""
              :title="$t('global.export')"
            />
          </div>
        </div>
      </PageSection>
    </template>
  </BaseWorkPageLayout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TheInvoicingExportPage',
  components: {},
  data() {
    return {
      company: {},
      due_date: null,
      date_formatter: {
        date: 'DD/MM/YYYY',
        month: 'MM'
      },
      with_exported: false,
      mark_exported: false
    }
  },
  computed: {
    ...mapGetters({
      companies: 'company/getCompaniesList',
      errors: 'auth/getErrors'
    })
  },
  methods: {
    ...mapMutations({ setErrors: 'auth/setErrors' }),
    ...mapActions({
      fetchCompaniesList: 'company/fetchCompanyIndex',
      fecthInvoiceExport: 'invoicing/fecthInvoiceExport'
    }),
    getInputValue({ attribute, value }) {
      if (attribute === 'with_exported') {
        return (this.with_exported = !this.with_exported)
      } else if (attribute === 'mark_exported') {
        return (this.mark_exported = !this.mark_exported)
      }
    },
    submitForm() {
      this.fecthInvoiceExport({
        company: this.company,
        period: { from: this.due_date?.startDate, to: this.due_date?.endDate },
        with_exported: this.with_exported,
        mark_exported: this.mark_exported
      })
    }
  },
  mounted() {
    this.fetchCompaniesList()
  }
}
</script>
